import React from "react";

export const WAHeaderIconRow: React.FC<{}> = props => (
  <ul className="wa-header-icon-row">{props.children}</ul>
);
